/**
 * Admin site entry point (admin.brokeornot.com) — quick-260909-k4v.
 *
 * Import order is critical and mirrors the main app's src/main.tsx:
 * 1. Amplify.configure MUST run before any Amplify SDK usage
 * 2. Global CSS before component styles
 *
 * Deliberately much smaller than the main app's entry: no router (one screen), no service
 * worker, no Capacitor native registrations, no analytics. The admin site is web-only and
 * has nothing to install or track.
 *
 * NOTHING here may touch window.location before Amplify has finished the OAuth exchange.
 * An earlier version of this file stripped ?code=&state= from the URL at module scope to
 * tidy the address bar, which silently broke Google sign-in outright: Amplify's
 * attemptCompleteOAuthFlow awaits oAuthStore.loadOAuthInFlight() BEFORE it reads
 * window.location.href, so a synchronous rewrite here always wins the race and Amplify
 * sees a URL with no authorization code in it. The address bar is tidied in AdminApp
 * instead, after authentication has actually succeeded.
 */
import './amplifyAdmin'; // configure Amplify before rendering
import '@/index.css'; // the SAME stylesheet and design tokens as app.brokeornot.com

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AdminApp } from './AdminApp';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The report is a point-in-time snapshot with an explicit Refresh button, so there is
      // no value in refetching it on every window focus.
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AdminApp />
    </QueryClientProvider>
  </StrictMode>
);
